import { render } from "./WrapWithSection.vue?vue&type=template&id=23f70d71&scoped=true"
import script from "./WrapWithSection.vue?vue&type=script&lang=js"
export * from "./WrapWithSection.vue?vue&type=script&lang=js"

import "./WrapWithSection.vue?vue&type=style&index=0&id=23f70d71&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f70d71"]])

export default __exports__